import React, { useState, useEffect } from 'react'
import TogglesContainer from './TogglesContainer'
import CardsContainer from './CardsContainer'
import Card from './Card'
import PagesHeader from '../../common/components/PagesHeader'

function PricingPlans({ isDesktop }) {
  const [monthlyRepayment, setMonthlyRepayment] = useState('0');
  const [specialTypeRepayment, setSpecialTypeRepayment] = useState('0');
  const [regularTypeRepayment, setRegularTypeRepayment] = useState('0');
  const [poorTypeRepayment, setPoorTypeRepayment] = useState('0');
  const [leaseDocTypeRepayment, setLeaseDocTypeRepayment] = useState('0');
  const [smsfResidentRepayment, setSmsfResidentRepayment] = useState('0');

  const [specialTypeRate, setSpecialTypeRate] = useState('0');
  const [regularTypeRate, setRegularTypeRate] = useState('0');
  const [poorTypeRate, setPoorTypeRate] = useState('0');
  const [leaseDocTypeRate, setLeaseDocTypeRate] = useState('0');
  const [smsfResidentRate, setSmsfResidentRate] = useState('0');

  const [isOwnHome, setIsOwnHome] = useState(true);
  const [isInterestOnly, setIsInterestOnly] = useState(false);

  const [cardHeader60, setCardHeader60] = useState('Low rate home loan');
  const [cardHeader80, setCardHeader80] = useState('Offset home loan');
  const [cardHeader90, setCardHeader90] = useState('Low doc home loan');

  const loanObjective = isOwnHome ? 'live' : 'invest'
  const repaymentType = isInterestOnly ? 2 : 0
  
  const displayFourCards = isOwnHome ? 'display-three-cards' : 'display-four-cards'

  return (
    <div>
      <div className="jumbotron jumbotron-fluid jumbotron-fixed-height">
        <div className="container">
          <PagesHeader
            header="Compare our home and investor loan interest rates"
            body="Whether you are a property buyer or looking to refinance your existing loan, Yard has low mortgage interest rates for both owner-occupiers and investors."
          />
          <TogglesContainer
            specialTypeRate={specialTypeRate}
            regularTypeRate={regularTypeRate}
            poorTypeRate={poorTypeRate}
            leaseDocTypeRate={leaseDocTypeRate}
            setSpecialTypeRepayment={setSpecialTypeRepayment}
            setRegularTypeRepayment={setRegularTypeRepayment}
            setPoorTypeRepayment={setPoorTypeRepayment}
            setLeaseDocTypeRepayment={setLeaseDocTypeRepayment}
            setSmsfResidentRepayment={setSmsfResidentRepayment}
            setIsOwnHome={setIsOwnHome}
            setIsInterestOnly={setIsInterestOnly}
            setCardHeader60={setCardHeader60}
            setCardHeader80={setCardHeader80}
            setCardHeader90={setCardHeader90}
            isOwnHome={isOwnHome}
            isInterestOnly={isInterestOnly}
          />
        </div>
      </div>
      <CardsContainer displayFourCards={displayFourCards}>
        <Card
          cardHeaderText={cardHeader60}
          lvr={isInterestOnly ? "smsf_commercial" : "60"}
          theme="green"
          font="white"
          applyNow="btn-white"
          talkToExpert="talk-to-expert-btn-grey-hover"
          applyButton="apply-now-button"
          monthlyPayment={specialTypeRepayment}
          loanObjective={loanObjective}
          repaymentType={repaymentType}
          setSpecialTypeRate={setSpecialTypeRate}
          setRegularTypeRate={setRegularTypeRate}
          setPoorTypeRate={setPoorTypeRate}
          isInterestOnly={isInterestOnly}
          isDesktop={isDesktop}
          isOwnHome={isOwnHome}
          displayFourCards={displayFourCards}
        />
        <Card
          cardHeaderText={cardHeader80}
          lvr="80"
          theme="black"
          font="black"
          applyNow="btn-green"
          applyButton=""
          talkToExpert="btn-line-green green hover-light-green"
          monthlyPayment={regularTypeRepayment}
          loanObjective={loanObjective}
          repaymentType={repaymentType}
          setSpecialTypeRate={setSpecialTypeRate}
          setRegularTypeRate={setRegularTypeRate}
          setPoorTypeRate={setPoorTypeRate}
          isInterestOnly={isInterestOnly}
          isDesktop={isDesktop}
          isOwnHome={isOwnHome}
          displayFourCards={displayFourCards}
        />
        {!isOwnHome && isInterestOnly && (
          <Card
            cardHeaderText="Lease doc loan"
            lvr="lease_doc"
            theme="black"
            font="black"
            applyNow="btn-green"
            applyButton=""
            talkToExpert="btn-line-green green hover-light-green"
            monthlyPayment={leaseDocTypeRepayment}
            loanObjective={loanObjective}
            repaymentType={repaymentType}
            setSpecialTypeRate={setSpecialTypeRate}
            setRegularTypeRate={setRegularTypeRate}
            setPoorTypeRate={setPoorTypeRate}
            setLeaseDocTypeRate={setLeaseDocTypeRate}
            isInterestOnly={isInterestOnly}
            isDesktop={isDesktop}
            isOwnHome={isOwnHome}
            displayFourCards={displayFourCards}
          />
        )}
        <Card
          cardHeaderText={cardHeader90}
          lvr="90"
          theme="black"
          font="black"
          applyNow="btn-green"
          applyButton=""
          talkToExpert="btn-line-green green hover-light-green"
          monthlyPayment={poorTypeRepayment}
          loanObjective={loanObjective}
          repaymentType={repaymentType}
          setSpecialTypeRate={setSpecialTypeRate}
          setRegularTypeRate={setRegularTypeRate}
          setPoorTypeRate={setPoorTypeRate}
          isInterestOnly={isInterestOnly}
          isDesktop={isDesktop}
          isOwnHome={isOwnHome}
          displayFourCards={displayFourCards}
        />
        {!isOwnHome && !isInterestOnly && (
          <Card
            cardHeaderText="SMSF residential loan"
            lvr="smsf"
            theme="black"
            font="black"
            applyNow="btn-green"
            applyButton=""
            talkToExpert="btn-line-green green hover-light-green"
            monthlyPayment={smsfResidentRepayment}
            loanObjective={loanObjective}
            repaymentType={repaymentType}
            setSpecialTypeRate={setSpecialTypeRate}
            setRegularTypeRate={setRegularTypeRate}
            setPoorTypeRate={setPoorTypeRate}
            setSmsfResidentRate={setSmsfResidentRate}
            isInterestOnly={isInterestOnly}
            isDesktop={isDesktop}
            isOwnHome={isOwnHome}
            displayFourCards={displayFourCards}
          />
        )}
      </CardsContainer>
    </div>
  );
}

export default PricingPlans
